<template>
    <div class="welcome page">
        <div class="content">
            <h2>Get early access</h2>
            <div class="form-container">
                <!-- Begin MailChimp Signup Form -->
                <div id="mc_embed_signup">
                    <form action="https://impactstory.us4.list-manage.com/subscribe/post?u=26fcc4e14b24319755845d9e0&amp;id=6432715697"
                          method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"
                          class="validate" target="_blank" novalidate>
                        <div id="mc_embed_signup_scroll">

                            <div class="mc-field-group">
                                <label for="mce-EMAIL">Email Address </label>
                                <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
                            </div>
                            <div class="mc-field-group">
                                <label for="mce-FNAME">First Name </label>
                                <input type="text" value="" name="FNAME" class="" id="mce-FNAME">
                            </div>
                            <div class="mc-field-group">
                                <label for="mce-LNAME">Last Name </label>
                                <input type="text" value="" name="LNAME" class="" id="mce-LNAME">
                            </div>
                            <div id="mce-responses" class="clear">
                                <div class="response" id="mce-error-response" style="display:none"></div>
                                <div class="response" id="mce-success-response" style="display:none"></div>
                            </div>
                            <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text"
                                                                                                      name="b_26fcc4e14b24319755845d9e0_6432715697"
                                                                                                      tabindex="-1"
                                                                                                      value=""></div>
                            <div class="clear"><input class="md-button md-primary md-raised" type="submit" value="Subscribe" name="subscribe"  id="mc-embedded-subscribe" ></div>
                        </div>
                    </form>
                </div>

                <!--End mc_embed_signup-->

            </div>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'earlyAccess'
    }
</script>


<style scoped lang="scss">



</style>


